import 'dayjs/locale/de';

import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import Link from '~/components/Link';
import { DEFAULT_REGION, type Region } from '~/utils/region';

dayjs.extend(utc);
dayjs.extend(timezone);

export function formatDate(
  unixTimestamp: number,
  region: Region = DEFAULT_REGION
) {
  return dayjs(unixTimestamp * 1000)
    .tz(region.timeZone)
    .locale(region.lang)
    .format('DD MMM YY h:mmA');
}

type Author = {
  name: string;
  path: string;
  title: string;
};

type Props = {
  author: Author;
  className?: string;
  modifiedDate?: number;
  publishedDate?: number;
  title: string;
};

function FeatureMetadata({
  title,
  author,
  publishedDate,
  modifiedDate
}: Props) {
  const displayDate = modifiedDate || publishedDate;
  const isUpdated = modifiedDate && modifiedDate !== publishedDate;

  return (
    <div className="content-width flex w-full flex-col items-center gap-2 text-center lg:gap-4">
      <div className="text-hero text-balance">{title}</div>
      <div className="text-caption-grey flex flex-wrap items-center justify-center gap-4">
        {displayDate && (
          <>
            <span>
              {isUpdated ? 'Updated ' : ''}
              {formatDate(displayDate)}
            </span>
            <span className="select-none">•</span>
          </>
        )}
        <Link
          to={author.path}
          external
          className="underline hover:text-gray-700"
        >
          {author.name}
        </Link>
      </div>
    </div>
  );
}

export function Header({
  title,
  author,
  publishedDate,
  modifiedDate,
  className
}: Props) {
  return (
    <div
      className={`flex w-full items-center justify-center bg-white py-10 text-black ${className ?? ''}`}
    >
      <FeatureMetadata
        title={title}
        author={author}
        publishedDate={publishedDate}
        modifiedDate={modifiedDate}
      />
    </div>
  );
}
